import jQueryBridget from 'jquery-bridget'
import Flickity from 'flickity'
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';

export default {
  init() {
    // JavaScript to be fired on the home page
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);

    $('.mobile-carousel').flickity({
      wrapAround: false,
      pageDots: false,
      autoPlay: false,
      draggable: true,
      imagesLoaded: true,
      setGallerySize: true,
      prevNextButtons: false,
      watchCSS: true,
    });

    var teamGallery = $('.team-gallery').flickity({
      wrapAround: true,
      pageDots: false,
      autoPlay: 8000,
      draggable: false,
      imagesLoaded: true,
      prevNextButtons: false,
    });

    $('.team-gallery').on('click', function () {
      teamGallery.flickity('next', true);
    });

    $('.testimonials-gallery').flickity({
      asNavFor: '.testimonials',
      wrapAround: true,
      pageDots: false,
      draggable: false,
      autoPlay: false,
      imagesLoaded: true,
      prevNextButtons: false,
    });

    var testimonials = $('.testimonials').flickity({
      wrapAround: true,
      pageDots: false,
      autoPlay: 8000,
      setGallerySize: true,
      // adaptiveHeight: true, // Works but makes text jump
      prevNextButtons: false,
    });

    $('.testimonial-btn-next').on('click', function () {
      testimonials.flickity('next', true);
    });

    $('.slide-btn-prev').on( 'click', function() {
      testimonials.flickity( 'previous', true );
    });

    $('.slide-btn-next').on( 'click', function() {
      testimonials.flickity( 'next', true );
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js